// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const transition: Styleguide["transition"] = {
    /* Store Custom Code - Start */
    duration: {
        none: 0,
    },
    /* Store Custom Code - End */
};

export default transition;
